export enum UnleashFlags {
  OOS_MEETING_APP_VERSION = 'oos-meeting-app-version',
  OOS_MEET_NOW_VERSION = 'oos-meeting-meetnow-version',
  OOS_MEETING_BG_SERVICE_VERSION = 'oos-meeting-bg-service-version',
  OOS_TRAINING_VERSION = 'oos-training-app-version',
  OOS_WEBINAR_VERSION = 'oos-webinar-app-version',
  OOS_WEBINAR_V2_VERSION = 'oos-webinar-app-v2-version',
  OOS_TEASER_VERSION = 'oos-teaser-app-version',
}
